import { CodeListStatus, PassOrFail } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";



@Entity("qc_clearance_info")
export class QcClearanceInfo {

    @PrimaryGeneratedColumn("increment", { name: 'clearance_id' })
    clearanceId: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;



    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

      @VersionColumn({
            default: 1,
            name: "version_flag"
        })
        versionFlag: number;
    
        @Column({
            type:"int",
            nullable: false,
            name: "so_id"
          })
         soId: number;

         @Column({
            type:"int",
            nullable: true,
            name: "code_list_log_id"
          })
         codeListLogId: number;

         @Column({
            type:"int",
            nullable: false,
            name: "code_list_main_id"
          })
         codeListMainId: number;

         @Column('varchar',{
            nullable: false,
            name: 'po_number',
            length: 50
        })
        poNumber: string;

        @Column({
            type: 'int',
            nullable: false,
            name: 'so_item_id'
        })
        soItemId: number;
    
        @Column({
            type:'enum',
            name: 'chemical_result',
            enum:PassOrFail,
            nullable: true,
        })
        chemicalResult: PassOrFail;
        
        @Column({
            type:'enum',
            name: 'micro_result',
            enum:PassOrFail,
            nullable: true,
        })
        microResult: PassOrFail;

        @Column({
            type:'enum',
            name: 'fg_result',
            enum:PassOrFail,
            nullable: true,
        })
        fgResult: PassOrFail;

        @Column({
            type:'enum',
            name: 'others',
            enum:PassOrFail,
            nullable: true,
        })
        others: PassOrFail;

        @Column('varchar', {
            name: 'c_file',
            length: 255, 
            nullable: true,
        })
        cFile: string;

        @Column('varchar', {
            name: 'm_file',
            length: 255, 
            nullable: true,
        })
        mFile: string;

        @Column('varchar', {
            name: 'fg_file',
            length: 255, 
            nullable: true,
        })
        fgFile: string;

        @Column('varchar', {
            name: 'others_file',
            length: 255, 
            nullable: true,
        })
        othersFile: string;
        
        @Column({
            type:'enum',
            name: 'clearance_status',
            enum:CodeListStatus
        })
        clearanceStatus: CodeListStatus;

        @Column({
            type:'enum',
            name:'overall_result',
            enum:PassOrFail
        })
        overallResult:PassOrFail
        
        





}